import { render, staticRenderFns } from "./kaumXstrataJR2.vue?vue&type=template&id=56023462&scoped=true"
import script from "./kaumXstrataJR2.vue?vue&type=script&lang=js"
export * from "./kaumXstrataJR2.vue?vue&type=script&lang=js"
import style0 from "./kaumXstrataJR2.vue?vue&type=style&index=0&id=56023462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56023462",
  null
  
)

export default component.exports